import React from 'react';
import { DateTime } from 'luxon';

import { Icon, Layout, Text } from 'ds';
import { formatDate } from 'shared/time';
import { selectNextConsumablesOrdersDeliveryDate } from 'store/App/selectors';
import { useAppSelector } from 'store/hooks';

const ConsumablesOnboardingRestockingInfoMessage: React.FC = () => {
  const nextConsumablesOrdersDeliveryDate = useAppSelector(selectNextConsumablesOrdersDeliveryDate);
  if (!nextConsumablesOrdersDeliveryDate) return null;
  const eightDaysBeforeDeliveryDate = DateTime.fromISO(nextConsumablesOrdersDeliveryDate).minus({ days: 8 });

  return (
    <Layout direction="row" gap={8} borderRadius={8} paddingX={8} paddingY={12} color="purple-gradient-transparent">
      <Icon name="info" size="xs" color="purple-gradient" />
      <Text size="body-xs" color="purple-gradient" semibold>
        Start today and get your first delivery on{' '}
        {formatDate({ date: DateTime.fromISO(nextConsumablesOrdersDeliveryDate), format: 'MED_WITH_SHORT_WEEKDAY' })}.
        Modify or cancel this order before{' '}
        {formatDate({ date: eightDaysBeforeDeliveryDate, format: 'MED_WITH_SHORT_WEEKDAY' })}.
      </Text>
    </Layout>
  );
};

export default ConsumablesOnboardingRestockingInfoMessage;
